module.exports = __webpack_public_path__ + "static/media/organization.vacancies.497e0f52.svg";